import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import familyRoomNew1 from "@/assets/family-room-new-1.jpg";
import familyRoomNew2 from "@/assets/family-room-new-2.jpg";
import doubleRoomNew1 from "@/assets/double-room-new-1.jpg";
import doubleRoomNew2 from "@/assets/double-room-new-2.jpg";
import doubleRoomNew3 from "@/assets/double-room-new-3.jpg";
import singleRoomNew1 from "@/assets/single-room-new-1.jpg";

const Rooms = () => {
  const roomTypes = [
    {
      id: "family",
      title: "Family Room",
      subtitle: "Perfect for families",
      description: "Spacious family accommodation with separate sleeping areas, perfect for parents and children. Features modern amenities and comfortable furnishings.",
      features: ["2 Double Beds", "Family Bathroom", "Mini Fridge", "Coffee Station", "Garden View"],
      images: [familyRoomNew1, familyRoomNew2, doubleRoomNew1]
    },
    {
      id: "double",
      title: "Double/Twin Room", 
      subtitle: "Comfortable and elegant",
      description: "Beautifully appointed double or twin room with modern amenities and stunning views of the surrounding landscape.",
      features: ["King/Twin Beds", "En-suite Bathroom", "Air Conditioning", "Work Desk", "Balcony"],
      images: [doubleRoomNew2, doubleRoomNew3, doubleRoomNew1]
    },
    {
      id: "single",
      title: "Single Room",
      subtitle: "Cozy retreat",
      description: "Intimate single room designed for solo travelers, offering all essential amenities in a comfortable setting.",
      features: ["Single Bed", "En-suite Bathroom", "Work Area", "Mini Bar", "Wi-Fi"],
      images: [singleRoomNew1, doubleRoomNew2, doubleRoomNew1]
    }
  ];

  return (
    <div className="min-h-screen py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="font-heading text-5xl font-bold text-foreground mb-6">Our Rooms</h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Choose from our selection of beautifully appointed rooms, each featuring modern amenities 
            and traditional African hospitality.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {roomTypes.map((room, index) => (
            <Card key={index} className="overflow-hidden shadow-soft hover:shadow-elegant transition-shadow">
              <CardContent className="p-0">
                <div className="relative h-80 rounded-lg overflow-hidden mb-6">
                  <img 
                    src={room.images[0]} 
                    alt={room.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                
                <div className="px-6 pb-6">
                  <div className="mb-2">
                    <span className="text-sm text-primary font-medium">{room.subtitle}</span>
                  </div>
                  <h3 className="font-heading text-2xl font-bold text-foreground mb-3">
                    {room.title}
                  </h3>
                  <p className="text-muted-foreground mb-4 leading-relaxed">
                    {room.description}
                  </p>
                  
                  <div className="space-y-2 mb-4">
                    {room.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center text-sm text-muted-foreground">
                        <div className="w-2 h-2 bg-primary rounded-full mr-3 flex-shrink-0"></div>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  
                  <Button asChild className="w-full bg-primary hover:bg-primary/90">
                    <Link to={`/rooms/${room.id}`}>View Details</Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Rooms;